import { SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import {
    modeOfHoldingSingle,
    portfoliosByTransactionResource,
    ctPortfoliosByMinorStatus,
    portfoliosByPurchaseAllow,
    portfoliosByPurchaseOrSipAllow,
    portfoliosWithIFSC,
    ctPortfoliosByNROAccountType,
    ctPortfoliosByBankAccount,
} from '../../portfolios/utils';

export enum DATE_VALUES {
    startDateInterval = 60,
}

export const apDividendFilters: Function[] = [
    ctPortfoliosByBankAccount,
    modeOfHoldingSingle,
    portfoliosByTransactionResource,
    ctPortfoliosByMinorStatus,
    ctPortfoliosByNROAccountType,
    portfoliosByPurchaseAllow,
    ({ isin }: SCHEMES_RESPONSE) => !!isin,
    // portfoliosWithIFSC,
];

export type summaryType = {
    amc: string;
    amcName: string;
    costValue: number;
    currentMarketValue: number;
    gainLoss: number;
    gainLossPercentage: number;
    isDemat: string;
};
export type portfolioDetailsType = {
    schemes: [SCHEMES_RESPONSE];
    summary: {
        demat: summaryType;
        non_demat: summaryType;
    };
};
